import { Flex, Input, Select } from "antd";
import {
    getCountries,
    getCountryCallingCode,
    parsePhoneNumberFromString,
} from "libphonenumber-js";
import { useMemo } from "react";

const regionNames = new Intl.DisplayNames(["en"], { type: "region" });

const CustomPhoneInput = ({ value, onChange, disabled = false }) => {
    const countries = useMemo(
        () =>
            getCountries().map((code) => ({
                code,
                name: regionNames.of(code) || code,
                dialCode: `+${getCountryCallingCode(code)}`,
            })),
        []
    );

    const country = value?.country || "GB";
    const phoneNumber = value?.phoneNumber || "";

    const triggerChange = (changedValue) => {
        const merged = { country, phoneNumber, ...changedValue };

        let parsed;
        try {
            parsed = parsePhoneNumberFromString(merged.phoneNumber, merged.country);
        } catch { }

        onChange?.({
            ...merged,
            phoneNumber: parsed?.number || merged.phoneNumber,
        });
    };

    const handleCountryChange = (newCountry) => {
        const dialCode = `+${getCountryCallingCode(newCountry)}`;
        let newNumber = phoneNumber;

        if (!newNumber.startsWith("+")) {
            newNumber = dialCode;
        } else {
            newNumber = newNumber.replace(/^\+\d+/, dialCode);
        }

        triggerChange({ country: newCountry, phoneNumber: newNumber });
    };

    const handlePhoneChange = (e) => {
        let input = e.target.value;

        if (!input.startsWith("+")) {
            input = `+${getCountryCallingCode(country)}${input.replace(/^0+/, "")}`;
        }

        triggerChange({ phoneNumber: input });
    };

    return (
        <Flex direction="row" gap={8}>
            <Select
                style={{ width: "100px" }}
                value={country}
                onChange={handleCountryChange}
                showSearch
                optionFilterProp="label"
                disabled={disabled}
                popupMatchSelectWidth={false}
                virtual
            >
                {countries.map((c) => (
                    <Select.Option
                        key={c.code}
                        value={c.code}
                        label={`${c.name} ${c.code} ${c.dialCode}`}
                    >
                        <span className={`fi fi-${c.code.toLowerCase()}`} />{' '}
                        {c.name} ({c.dialCode})
                    </Select.Option>
                ))}
            </Select>

            <Input
                style={{ flex: 1 }}
                placeholder="Phone number"
                value={phoneNumber}
                onChange={handlePhoneChange}
                readOnly={disabled}

                onKeyPress={(e) => {
                    if (!/[0-9+]/.test(e.key)) {
                        e.preventDefault();
                    }
                    if (e.key === "+" && phoneNumber.includes("+")) {
                        e.preventDefault();
                    }
                }}
                onPaste={(e) => {
                    let pasted = e.clipboardData.getData("Text");
                    pasted = pasted.replace(/[^0-9+]/g, "");
                    e.preventDefault();
                    triggerChange({ phoneNumber: pasted });
                }}

            />
        </Flex>
    );
};

export default CustomPhoneInput;
